import React, { Component } from "react";
import {
    Column,
    ColumnChooser,
    FilterRow,
    SearchPanel,
    Lookup,
    Pager,
    Paging,
    Export,
    Button as ButtonGrid, 
    RequiredRule,
    Editing,
    Form,
    StringLengthRule,
    Popup
}
    from 'devextreme-react/data-grid';
import { DataGrid } from 'devextreme-react';
import { createStore } from "../../utils/proxy";
import { Item } from 'devextreme-react/form';
import BlockHeader from '../../components/shared/BlockHeader';
import Title from "../../components/shared/Title";
import { store } from "../../services/store";
import { formatNumberPhone } from "../../utils/common";
import uri from "../../utils/uri";
import onExporting from '../../components/grids/Importer';

const Templates = () => {

    let dataGrid = React.createRef();

    const onToolbarPreparing = (e) => {  
        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Agregar Plantilla',
                icon:'plus',
                type:'default',
                stylingMode:"outlined",
                onClick: () =>  dataGrid.current.instance.addRow()
            }
        },{
            location: 'after',
            widget: 'dxButton',
            options: {
                text: 'Exportar a excel',
                icon:'xlsxfile',
                type:'success',
                stylingMode:"outlined",
                onClick: () =>  dataGrid.current.instance.exportToExcel(false)
            }
        });
    }  

    const title = "Plantillas de notificaciones"

    return (
        <div className="container medium">
            <Title title={title}/>
            <BlockHeader title={title} />
            <DataGrid
                ref={dataGrid}
                dataSource={store({ uri : uri.notificationTemplates })}
                selection={{ mode: 'single' }}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                hoverStateEnabled={true}
                onToolbarPreparing={onToolbarPreparing}
                onExporting={(e) => onExporting(e, title)}
                remoteOperations={{
                    paging: true,
                    filtering: true
                }}                  
            >
                <Pager allowedPageSizes={[10, 15, 30, 50]} showPageSizeSelector={true} showInfo={true} />
                <Paging defaultPageSize={15} />
                <SearchPanel visible={true} width={250} />
                <FilterRow visible={true} />
                <Export enabled={false} fileName={title} allowExportSelectedData={true} />     
                <Column dataField="id" visible={false} allowEditing={false} />
                <Column dataField="name" caption="Nombre" width={180} >
                    <RequiredRule message="El nombre es requerido"/>
                </Column>
                <Column dataField="description" caption="Descripcion">
                    <RequiredRule message="El mensaje es requerido"/>
                    <StringLengthRule max={150}  message="Maximo 150 caracteres" />
                </Column>
                <Editing
                    mode="popup"
                    allowUpdating={true}
                    allowDeleting={true}
                    useIcons={true}
                >
                     <Popup title={title} showTitle={true} width={450} height={300}>
                        
                    </Popup>
                    <Form>
                        <Item  dataField="name" editorOptions={{ width:300 }} colSpan={2} >
                            <RequiredRule message="El nombre es requerido"/>
                            <StringLengthRule max={50} min={2} message="Máximo de caracteres 50 y 2 mínimo"/>
                        </Item>
                        <Item  dataField="description" editorOptions={{ width:300 }} colSpan={2} editorType="dxTextArea">
                            <RequiredRule message="El mensaje es requerido"/>
                            <StringLengthRule max={150} min={2} message="Máximo de caracteres 50 y 2 mínimo"/>
                        </Item>
                    </Form>
                </Editing>
            </DataGrid>
        </div>
    )
}

export default Templates;
